import { render } from "./TechnologySection.vue?vue&type=template&id=11872934&scoped=true"
import script from "./TechnologySection.vue?vue&type=script&lang=js"
export * from "./TechnologySection.vue?vue&type=script&lang=js"

import "./TechnologySection.vue?vue&type=style&index=0&id=11872934&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11872934"]])

export default __exports__